import { Suspense } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { AppLayout } from '@sorare/core/src/components/navigation/AppLayout';
import { useMainSport } from '@sorare/core/src/hooks/useMainSport';
import { lazy } from '@sorare/core/src/lib/retry';

const NBALanding = lazy(async () => import('@sorare/nba/src/pages/page'));
const FootballLanding = lazy(
  async () => import('@sorare/football/src/pages/page')
);

const landings = {
  [Sport.NBA]: NBALanding,
  [Sport.FOOTBALL]: FootballLanding,
};

const Landing = () => {
  const mainSport = useMainSport();
  const SportLanding = landings[mainSport];

  return (
    <AppLayout>
      <Suspense>
        <SportLanding isRoot />
      </Suspense>
    </AppLayout>
  );
};

export default Landing;
